import React from "react";
import ReactDOM from "react-dom/client";
import createCache from "@emotion/cache";
import AppProviders from "./rendering/AppProviders";
import { init as initAnalytics, setLocale } from "./lib/analytics";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./index.css";
import i18n from "./i18n/i18n";
import App from "./App";

initAnalytics({
  customProperties: () => ({
    // Fallback matches i18n's real fallbackLng ("it"), so an unresolved language
    // is reported as Italian (what the page actually renders), not English.
    locale: (i18n.language || "it").slice(0, 2),
    auth: localStorage.getItem("userToken") ? "logged_in" : "anonymous",
  }),
});

// Keep the `locale` dimension in sync whenever the active language changes
// (manual switch, or profile preferredLanguage sync after login).
i18n.on("languageChanged", (lng) => setLocale(lng));

const container = document.getElementById("root");
const snapshot = document.getElementById("public-page-data");
const data = snapshot ? JSON.parse(snapshot.textContent) : {};
const app = (
  <React.StrictMode>
    <AppProviders cache={createCache({ key: "css" })} data={data} initialAnonymous={!!snapshot}>
      <App />
    </AppProviders>
  </React.StrictMode>
);

if (snapshot) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
